// extracted by mini-css-extract-plugin
module.exports = {"title":"Cn","status":"Co","isRental":"Cp"};